import { useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';

import UnplacedMail from '../components/UnplacedMail.jsx';
import FetchMailButton from '../components/FetchMailButton.jsx';

// T412 — this page is being folded into Tasks, one step at a time.
//
// Everything it had now lives there: the queue since T392, the search since
// T412, and the alert-job importer moved to the dashboard, where its output
// lands. What is left here is the same queue component Tasks renders, plus a
// sign saying where the work moved to.
//
// It stays reachable on purpose. The roadmap's rollout for this is a
// strangler rather than a flip: the page keeps working while the visit
// counter (T410) says whether anyone still opens it, and only then does the
// route become a redirect. A page that vanishes the day it is replaced is
// how you find out afterwards that it was load-bearing.
//
// Rendering the shared component rather than its own copy is the other half.
// The bespoke version here is where the T411 bug lived: its delete button
// dropped the row locally and never called the API, because the behaviour
// sat in the host instead of the card. It also silently dropped the `total`
// and `truncated` fields the API returns, so T408's "showing N of M" line
// on this page could never fire — dead code the inventory had already
// flagged and I had shipped anyway.
export default function MailPage() {
  // T387's rule, which this page had and must keep: a fetch reloads what it
  // announces. Without the ref the button would report new mail over a list
  // that had not moved.
  const queueRef = useRef(null);
  const reload = useCallback(() => queueRef.current?.reload?.(), []);

  return (
    <div className="space-y-6">
      <section className="space-y-2">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <h2 className="text-sm font-medium text-brand-500">Unlinked mail</h2>
          <FetchMailButton onDone={reload} />
        </div>
        <p className="max-w-prose rounded-md border border-brand-700 bg-brand-600/5 px-3 py-2 text-xs text-slate-300">
          This moved to{' '}
          <Link to="/tasks" className="text-brand-400 underline decoration-dotted hover:text-brand-300">
            Tasks
          </Link>
          , alongside the stage changes to approve and everything else waiting on you. The same queue
          is below; the page stays here for now.
        </p>
      </section>

      <UnplacedMail ref={queueRef} />
    </div>
  );
}
